var exports = {
  "Nr": "PricingCard.module__card___R19UVT",
  "OW": "PricingCard.module__cardDefault___R19UVT" + " " + "PricingCard.module__card___R19UVT",
  "WI": "PricingCard.module__cardPopular___R19UVT" + " " + "PricingCard.module__card___R19UVT",
  "uX": "PricingCard.module__badgeSpace___R19UVT",
  "qS": "PricingCard.module__badge___R19UVT",
  "Ys": "PricingCard.module__badgeOnBrand___R19UVT",
  "HH": "PricingCard.module__badgePlaceholder___R19UVT",
  "zH": "PricingCard.module__popularBadge___R19UVT",
  "B_": "PricingCard.module__popularBadgeSpace___R19UVT",
  "r9": "PricingCard.module__disabled___R19UVT",
  "L5": "PricingCard.module__selectButton___R19UVT",
  "_C": "PricingCard.module__soldOutBadge___R19UVT",
  "hQ": "PricingCard.module__contentContainer___R19UVT",
  "JJ": "PricingCard.module__cardTitle___R19UVT",
  "UZ": "PricingCard.module__cardTitleDefault___R19UVT" + " " + "PricingCard.module__cardTitle___R19UVT",
  "_": "PricingCard.module__cardTitlePopular___R19UVT" + " " + "PricingCard.module__cardTitle___R19UVT",
  "CA": "PricingCard.module__cardPrice___R19UVT",
  "$V": "PricingCard.module__cardPriceDefault___R19UVT" + " " + "PricingCard.module__cardPrice___R19UVT",
  "pW": "PricingCard.module__cardPricePopular___R19UVT" + " " + "PricingCard.module__cardPrice___R19UVT",
  "ce": "PricingCard.module__cardPeriod___R19UVT",
  "Lo": "PricingCard.module__cardPeriodDefault___R19UVT" + " " + "PricingCard.module__cardPeriod___R19UVT",
  "xP": "PricingCard.module__cardPeriodPopular___R19UVT" + " " + "PricingCard.module__cardPeriod___R19UVT",
};

module.exports = exports;
